import React from 'react';
import { format, parseISO } from 'date-fns';
import { GlobalCalendarEvent, EVENT_TYPE_COLORS } from '../../types/calendar';

interface CalendarEventChipProps {
  event: GlobalCalendarEvent;
  onClick: (event: GlobalCalendarEvent) => void;
  compact?: boolean;
}

const CalendarEventChip: React.FC<CalendarEventChipProps> = ({ event, onClick, compact }) => {
  const colors = EVENT_TYPE_COLORS[event.type];

  return (
    <button
      onClick={e => {
        e.stopPropagation();
        onClick(event);
      }}
      className={`w-full text-left p-1 text-xs ${colors.bg} ${colors.text} rounded hover:opacity-80 transition-opacity truncate`}
      title={`${event.title} - ${event.projectName}`}
      aria-label={`${event.type}: ${event.title}`}
    >
      <div className="flex items-center space-x-1">
        <div className={`w-2 h-2 ${colors.dot} rounded-full flex-shrink-0`} />
        <span className="truncate font-medium">{event.title}</span>
      </div>
      {!compact && !event.allDay && (
        <div className="text-[10px] opacity-75 truncate mt-0.5 pl-3">
          {format(parseISO(event.startDate), 'HH:mm')}
          {event.projectName && ` \u2022 ${event.projectName}`}
        </div>
      )}
    </button>
  );
};

export default CalendarEventChip;
